import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings -> Easeedesk -> Automated User (v4/api,
 * `App\Settings\Easeedesk\EaseedeskAutomatedUser`): firmele furnizorului si
 * numele utilizatorului automat pe fiecare (0 = general). Forma paginii e
 * inghetata in `settings/easeedesk/__fixtures__/automatedUserSettings.json`.
 */
export interface AutomatedUserPage {
  providerName: string
  companies: { ID: number; name: string }[]
}

export interface AutomatedUserSettings {
  company: number
  user_name: string
}

export function automatedUserPageQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'automated_user'],
    queryFn: () => apiGet<AutomatedUserPage>('/settings/easeedesk/automated_user_settings'),
  })
}

export function automatedUserSettingsQuery(company: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'automated_user', company],
    queryFn: () => apiGet<AutomatedUserSettings>(`/settings/easeedesk/automated_user_settings/${company}`),
  })
}

/** `Easeedesk::save_automated_user_settings` - `company` + `user_name`. */
export function saveAutomatedUser(company: number, userName: string) {
  return apiPost<{ status: string }>('/settings/easeedesk/automated_user_settings', {
    company: String(company),
    user_name: userName,
  })
}
